var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgForwardArrow = function SvgForwardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.59 10.59 5.17 6 .59 1.41 2 0l6 6-6 6-1.41-1.41Z",
    fill: "#4B4B4B"
  })));
};

export default SvgForwardArrow;